var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyShifts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 105,
    viewBox: "0 0 113 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.5145 43.4791V86.9581C81.5145 88.9982 79.8405 90.6557 77.7801 90.6557H31.1635C29.1031 90.6557 27.4291 88.9982 27.4291 86.9581V27.286C27.4291 25.2459 29.1031 23.5883 31.1635 23.5883H61.4256C62.3915 23.5883 63.3573 23.9709 64.0655 24.6721L80.4199 40.8652C81.1282 41.5665 81.5145 42.5228 81.5145 43.4791Z",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1943 24.8634V38.2514C64.1943 39.7814 65.4821 41.0565 67.0274 41.0565H80.6775L64.1943 24.8634Z",
    stroke: "#5A4BF8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.792 52.9144H49.1276C47.9687 52.9144 47.0672 52.0219 47.0672 50.8743C47.0672 49.7268 47.9687 48.8342 49.1276 48.8342H71.792C72.951 48.8342 73.8524 49.7268 73.8524 50.8743C73.8524 52.0219 72.951 52.9144 71.792 52.9144Z",
    fill: "#DEDBFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.792 62.6685H49.1276C47.9687 62.6685 47.0672 61.7759 47.0672 60.6284C47.0672 59.4809 47.9687 58.5883 49.1276 58.5883H71.792C72.951 58.5883 73.8524 59.4809 73.8524 60.6284C73.8524 61.7122 72.951 62.6685 71.792 62.6685Z",
    fill: "#DEDBFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.792 72.3588H49.1276C47.9687 72.3588 47.0672 71.4663 47.0672 70.3188C47.0672 69.1712 47.9687 68.2787 49.1276 68.2787H71.792C72.951 68.2787 73.8524 69.1712 73.8524 70.3188C73.8524 71.4663 72.951 72.3588 71.792 72.3588Z",
    fill: "#DEDBFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6667 53.1694L35.9282 51.4481C35.4775 51.0018 35.4775 50.2368 35.9282 49.7905C36.3789 49.3443 37.1516 49.3443 37.6023 49.7905L38.5037 50.6831L41.5943 47.6229C42.045 47.1767 42.8177 47.1767 43.2684 47.6229C43.7191 48.0692 43.7191 48.8342 43.2684 49.2805L39.3407 53.1694C38.89 53.6157 38.1174 53.6157 37.6667 53.1694Z",
    fill: "#5A4BF8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6667 63.2423L35.9282 61.5209C35.4775 61.0747 35.4775 60.3097 35.9282 59.8634C36.3789 59.4171 37.1516 59.4171 37.6023 59.8634L38.5037 60.7559L41.5943 57.6958C42.045 57.2495 42.8177 57.2495 43.2684 57.6958C43.7191 58.1421 43.7191 58.9071 43.2684 59.3534L39.3407 63.2423C38.89 63.6885 38.1174 63.6885 37.6667 63.2423Z",
    fill: "#5A4BF8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6667 73.3789L35.9282 71.6576C35.4775 71.2113 35.4775 70.4463 35.9282 70C36.3789 69.5537 37.1516 69.5537 37.6023 70L38.5037 70.8925L41.5943 67.8324C42.045 67.3861 42.8177 67.3861 43.2684 67.8324C43.7191 68.2787 43.7191 69.0437 43.2684 69.49L39.3407 73.3789C38.89 73.8251 38.1174 73.8251 37.6667 73.3789Z",
    fill: "#5A4BF8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M94.0701 50.1093L80.4199 36.5938V88.9982H41.1436V96.1384C41.1436 98.1785 42.8177 99.8361 44.8781 99.8361H91.4302C93.4906 99.8361 95.1647 98.1785 95.1647 96.1384V52.7231C95.1647 51.7668 94.7784 50.8106 94.0701 50.1093Z",
    fill: "#5A4BF8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2148 17.8506C88.1706 17.8506 89.7561 16.2808 89.7561 14.3443C89.7561 12.4077 88.1706 10.8379 86.2148 10.8379C84.259 10.8379 82.6735 12.4077 82.6735 14.3443C82.6735 16.2808 84.259 17.8506 86.2148 17.8506Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4695 6.24772C40.9275 6.24772 42.1094 5.07746 42.1094 3.63388C42.1094 2.19029 40.9275 1.02003 39.4695 1.02003C38.0115 1.02003 36.8296 2.19029 36.8296 3.63388C36.8296 5.07746 38.0115 6.24772 39.4695 6.24772Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59373 21.9308L14.9379 27.2222",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59373 27.2222L14.9379 21.9308",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93162 56.6758L1.0302 65.7924C1.0302 65.9836 1.22336 66.1749 1.41652 66.0474L9.85128 62.2222C10.0444 62.1585 10.0444 61.9035 9.91567 61.776L2.38233 56.4845C2.18917 56.357 1.93162 56.4845 1.93162 56.6758Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.712 56.4208H102.44C102.247 56.4208 102.119 56.612 102.183 56.8033L106.819 64.7723C106.948 64.9636 107.205 64.9636 107.27 64.7723L111.905 56.8033C112.034 56.6758 111.905 56.4208 111.712 56.4208Z",
    stroke: "#ADABFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyShifts);
export default __webpack_public_path__ + "static/media/EmptyShifts.c6dad7112d27b04c8f26ead4abee2db3.svg";
export { ForwardRef as ReactComponent };